import { getId } from "./get-id";

export const getRandomUuid = (prefix = "") =>
  crypto?.randomUUID?.() || `${getId(prefix)}${Date.now()}`;
